import { type Author, authorName } from "@/models/author"
import type { Article } from "@/models/article.ts"

export function listAuthors (authors: Array<Author>): string {
  return authors.map(author => authorName(author)).join(', ')
}

export function getLocalizedAbstract (article: Article): string | null {
  let selectedLanguage = I18n.locale

  return article[`abstract_${selectedLanguage}` as 'abstract_it' | 'abstract_en'] || null
}